import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { http, errMsg } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("sd_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-[#041214] px-5">
      <div className="pointer-events-none absolute right-0 top-0 h-96 w-96 rounded-full bg-[#0D9488]/20 blur-[120px]" />
      <form onSubmit={submit} className="relative w-full max-w-sm space-y-5 rounded-md border border-[#163D43] bg-[#071D1F] p-8" data-testid="admin-login-form">
        <LogoMark className="h-12 w-12" />
        <div>
          <h1 className="font-display text-3xl font-semibold text-teal-50">Painel S'Designer</h1>
          <p className="mt-1 text-sm text-teal-200">Acesso restrito ao administrador.</p>
        </div>
        <Input type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" className="border-[#163D43] bg-[#041214] text-teal-50" />
        <Input type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" className="border-[#163D43] bg-[#041214] text-teal-50" />
        {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-[#2DD4BF] py-3 font-semibold text-[#041214] transition-opacity disabled:opacity-60">
          {loading ? "Entrando..." : "Entrar"}
        </button>
        <Link to="/" className="block text-center text-sm text-teal-300 hover:text-[#2DD4BF]" data-testid="admin-login-back">← Voltar ao site</Link>
      </form>
    </div>
  );
}
